<template>
  <div>
    <!-- 标签批量修改条码格式 -->
    <el-dialog title="标签批量修改条码格式" :close-on-click-modal="false" :visible.sync="dialogVisible" width="780px" center>
      <div class="content">
        <div class="row">
          <div class="label">
            原始仓库类型:
          </div>
          <div class="val">
            <el-radio-group v-model="datas.from_no_type">
              <el-radio :label="'FBA'">亚马逊FBA</el-radio>
              <el-radio :label="'LETIAN'">乐天</el-radio>
              <el-radio :label="'YAHU'">雅虎</el-radio>
              <el-radio :label="'ZOZO'">ZOZO</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="row">
          <div class="label">
            原始标签编码格式:
          </div>
          <div class="val">
            <el-radio-group v-model="datas.from_code_type">
              <el-radio :label="'CODE128'">CODE128</el-radio>
              <el-radio :label="'EN13'">EN13</el-radio>
              <el-radio :label="'EN8'">EN8</el-radio>
              <el-radio :label="'CODE39'">CODE39</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="border"></div>
        <div class="row">
          <div class="label">
            目标仓库类型:
          </div>
          <div class="val">
            <el-radio-group v-model="datas.to_no_type">
              <el-radio :label="'FBA'">亚马逊FBA</el-radio>
              <el-radio :label="'LETIAN'">乐天</el-radio>
              <el-radio :label="'YAHU'">雅虎</el-radio>
              <el-radio :label="'ZOZO'">ZOZO</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="row">
          <div class="label">
            目标标签编码格式:
          </div>
          <div class="val">
            <el-radio-group v-model="datas.to_code_type">
              <el-radio :label="'CODE128'">CODE128</el-radio>
              <el-radio :label="'EN13'">EN13</el-radio>
              <el-radio :label="'EN8'">EN8</el-radio>
              <el-radio :label="'CODE39'">CODE39</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">
          {{ $t("message.ok") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: {
    porder_sn: { type: String },
  },
  data() {
    return {
      datas: {
        from_code_type: '',
        to_code_type: '',
        porder_sn: '',
        from_no_type: '',
        to_no_type: '',
      },
      dialogVisible: false,
    };
  },
  methods: {
    setData(data) {
      this.datas = {
        from_code_type: '',
        to_code_type: '',
        from_no_type: '',
        to_no_type: '',
        porder_sn: data.porder_sn,
        porder_detail_tag_id_set: data.porder_detail_tag_id_set
      }
      this.dialogVisible = true
    },
    // 保存
    save() {
      this.$api.porderApi.batchModifyCodeType(this.datas).then(res => {
        this.$message.success(res.data)
        this.dialogVisible = false
        this.$store.dispatch("porderDetail", { porder_sn: this.datas.porder_sn });

      })
    },

  },
};
</script>
<style lang='scss' scoped>
/deep/.el-radio__inner {
  transform: scale(1.5) !important;
}

.content {
  margin: 0px 15px;

  .row {
    display: flex;
    margin-bottom: 20px;

    .label {
      line-height: 40px;
      margin-right: 30px;
    }

    .val {
      flex: 3;
      line-height: 40px;
    }
  }

  .border {
    margin: 20px 0px;
    height: 1px;
    width: 100%;
    background: #ccc;
  }

  .table {
    border: 1px solid #edeff4;

    ol {
      display: flex;
    }

    ul {
      display: flex;
      padding: 0;
      border: 0;

      li {
        padding: 24px 0;
      }
    }

    li {
      border-right: 1px solid #edeff4;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex15 {
      flex: 1.5;
    }
  }

  /deep/.el-input {
    width: 60%;
  }

  /deep/.el-select {
    .el-input {
      width: 100%;
    }

    width: 80%;
  }
}
</style>